// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lSqd","title":"styles_title__15gn8"};